import React, {useState} from 'react';
import './MultiTableProduct.scss';
import TitleWithLine from "../TitleWithLine/TitleWithline";
import Button from "../../UI/Button";
import MultiData from "./MultiData";
import _axios from "../../../httpService";
import {toast} from "react-toastify";
import NumericFunction from "../../../utils/NumericFunction";
import utilsFunction from "../../../utils/utilsFunction";
import {useNavigate} from "react-router-dom";

function MultiTableProduct({show, forBack, setForBack, sendData}) {

  const navigateTo = useNavigate();
  const [isPending, setIsPending] = useState(false)

  function deleteRowHandler(uniqId) {
    let tempArray = forBack;
    tempArray = tempArray.filter(v => v.uniqId !== uniqId)
    setForBack(tempArray)
  }

  const changePriceHandler = (e, uniqId) => {
    let tempArray = [...forBack];
    for (let i = 0; i < tempArray.length; i++) {
      if (tempArray[i].uniqId === uniqId) {
        tempArray[i].price = NumericFunction.p2e(utilsFunction.removeComma(e.target.value))
        break;
      }
    }

    setForBack(tempArray)
  }

  const changeTe = (e, uniqId) => {

    let tempArray = [...forBack];
    for (let i = 0; i < tempArray.length; i++) {
      if (tempArray[i].uniqId === uniqId) {
        tempArray[i].internetId = e.target.value
        break;
      }
    }
    setForBack(tempArray)
  }

  const getUniqueObjects = (arr1, arr2) => {
    return arr1.filter(obj1 =>
      !arr2.some(obj2 => JSON.stringify(obj1) === JSON.stringify(obj2))
    );
  };

  const SendDataHandler = () => {
    setIsPending(true)
    if (sendData?.seriesId) {
      // mode edit
      const prevData = getUniqueObjects(sendData?.submittedProductFromBack, forBack);
      const data = {
        submittedData: forBack,
        prevData: prevData,
        seriesId: sendData?.seriesId,
        sendToSite: sendData?.sendToSite
      }
      _axios.post(localStorage.getItem("apiUrl") + "/kalaEntity/?request=editSeriesProducts", data)
        .then((response) => {
          if (response.data.status) {
            toast.success(response.data.message)
            navigateTo(-1)
          } else {
            toast.error(response?.data?.message)
            setIsPending(false)
          }
        })
    } else {
      // mode add
      const data = {data: forBack, sendToSite: sendData?.sendToSite}
      _axios.post(localStorage.getItem("apiUrl") + "/kalaEntity/?request=addKALA", data)
        .then((response) => {
          if (response.data.status) {
            toast.success(response.data.data)
            navigateTo(-1)
          } else {
            toast.error(response?.data?.message)
            setIsPending(false)
          }
        })
    }
  }

  try {
    return (
      <div style={{background: '#FFFFFF'}}>
        {show &&
          <>
            {forBack.length > 0 &&
              <>
                <TitleWithLine title="" LineClass="line-solid W-100"/>

                <div className="main-table">

                  <ul className="header-side">
                    <li style={{width: "5%"}}>ردیف</li>
                    <li style={{width: "30%"}}>نام کالا</li>
                    <li style={{width: "15%"}}>قیمت</li>
                    <li style={{width: "15%"}}>رنگ</li>
                    <li style={{width: "15%"}}>سایز</li>
                    <li style={{width: "15%"}}>کد کالای اینترنتی</li>
                    <li style={{width: "5%"}}>عملیات</li>
                  </ul>

                  <MultiData
                    multiData={forBack}
                    changeTe={changeTe}
                    changePriceHandler={changePriceHandler}
                    deleteRowHandler={deleteRowHandler}
                  />

                  <div className="button-center send-data-but">
                    <Button disabled={isPending} color={'pBtn'} onClick={SendDataHandler}>ثبت اطلاعات</Button>
                    {isPending && <h4>لطفا منتظر بمانید ...</h4>}
                  </div>
                </div>
              </>
            }
          </>
        }
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
}

export default MultiTableProduct;